import * as yup from "yup";
import { validationSchemas } from "./data";
export const branchTableInZoneSchema = yup.object().shape({
  TableName: validationSchemas.name,
  TableAmount: validationSchemas.numberInteger,
});
